var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "bg-FF p-t-16 p-b-20 m-b-12 b-r-8" }, [
      _c(
        "div",
        { staticClass: "flex space-between col-center m-b-20 p-l-16 p-r-16" },
        [
          _c("TitleLogo"),
          _c("span", { staticClass: "font-32 font-weight-500" }, [
            _vm._v("实施项目工时占比"),
          ]),
        ],
        1
      ),
      _c("div", {
        ref: "progressBar",
        staticStyle: { width: "96vw", height: "40px" },
        attrs: { id: "progressBar" },
      }),
      _c("div", { staticClass: "flex font-24 p-l-22 p-r-22" }, [
        _c("span", { staticClass: "m-r-56" }, [
          _vm._v(
            "实施项目：" +
              _vm._s(_vm.boardData.projectHour?.implementerHoursRatio) +
              "%"
          ),
        ]),
        _c("span", [
          _vm._v(
            "非实施项目：" +
              _vm._s(_vm.boardData.projectHour?.otherHoursRatio) +
              "%"
          ),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "bg-FF p-16 m-b-12 b-r-8" }, [
      _c(
        "div",
        { staticClass: "flex space-between col-center" },
        [
          _c("TitleLogo"),
          _c("span", { staticClass: "font-32 font-weight-500" }, [
            _vm._v("工时分析"),
          ]),
        ],
        1
      ),
      _c("div", { staticClass: "flex" }, [
        _c(
          "div",
          {
            staticClass: "flex-col row-between",
            staticStyle: { width: "40vw" },
          },
          [
            _c("div", { staticClass: "bg-C8FFEE p-20 text-center m-b-12" }, [
              _c("div", { staticClass: "font-36 font-weight-700 m-b-8" }, [
                _vm._v(_vm._s(_vm.boardData.hour?.averageHours)),
                _c("span", { staticClass: "font-16" }, [_vm._v(" 小时")]),
              ]),
              _c("div", { staticClass: "font-24" }, [_vm._v("人均工时")]),
            ]),
            _c("div", { staticClass: "bg-FFF1CF p-20 text-center" }, [
              _c("div", { staticClass: "font-36 font-weight-700 m-b-8" }, [
                _vm._v(_vm._s(_vm.boardData.hour?.hoursSaturation) + "%"),
              ]),
              _c("div", { staticClass: "font-24 m-b-2" }, [
                _vm._v("工时饱和度"),
              ]),
              _c("div", { staticClass: "cor-00B719 font-24" }, [
                _vm._v("高于平均水平"),
              ]),
            ]),
          ]
        ),
        _c("div", {
          ref: "workHourPie",
          staticStyle: { width: "60vw", height: "220px" },
          attrs: { id: "workHourPie" },
        }),
      ]),
    ]),
    _c("div", { staticClass: "bg-FF p-16 m-b-12 b-r-8" }, [
      _c(
        "div",
        { staticClass: "flex space-between col-center p-b-16" },
        [
          _c("TitleLogo"),
          _c("span", { staticClass: "font-32 font-weight-500" }, [
            _vm._v("反馈分析"),
          ]),
        ],
        1
      ),
      _c("div", { staticClass: "flex row-between p-b-20" }, [
        _c(
          "div",
          {
            staticClass:
              "width-49 bg-D4D5F7 b-r-8 flex col-center p-t-20 p-b-20 p-l-24 p-r-24",
          },
          [
            _vm._m(0),
            _c("div", [
              _c("div", { staticClass: "font-40 font-weight-700" }, [
                _vm._v(_vm._s(_vm.fkcs)),
              ]),
              _c("div", { staticClass: "font-24" }, [_vm._v("反馈次数")]),
            ]),
          ]
        ),
        _c(
          "div",
          {
            staticClass:
              "width-49 bg-F0E1FF b-r-8 flex col-center p-t-20 p-b-20 p-l-24 p-r-24",
          },
          [
            _vm._m(1),
            _c("div", [
              _c("div", { staticClass: "font-40 font-weight-700 cor-FE4C4E" }, [
                _vm._v(_vm._s(_vm.boardData.feedback?.wfkNum)),
              ]),
              _c("div", { staticClass: "font-24" }, [_vm._v("未反馈")]),
            ]),
          ]
        ),
      ]),
      _c("div", { staticClass: "feedback-table" }, [
        _c("table", { staticClass: "width-100" }, [
          _vm._m(2),
          _c("tbody", [
            _c("tr", [
              _vm._m(3),
              _c("td", [_vm._v(" 按时反馈 ")]),
              _c("td", [_vm._v(_vm._s(_vm.boardData.feedback?.fkNum) + "次")]),
              _c("td", { staticClass: "green" }, [
                _vm._v(_vm._s(_vm.boardData.feedback?.fkRatio) + "%"),
              ]),
            ]),
            _c("tr", [
              _vm._m(4),
              _c("td", [_vm._v(" 补录反馈 ")]),
              _c("td", [_vm._v(_vm._s(_vm.boardData.feedback?.blNum) + "次")]),
              _c("td", { staticClass: "red" }, [
                _vm._v(_vm._s(_vm.boardData.feedback?.blRatio) + "%"),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "w-72 h-72 m-r-16" }, [
      _c("img", {
        staticClass: "width-100 height-100",
        attrs: {
          alt: "反馈次数",
          src: require("@/assets/icon/employeeKanban/fankui.png"),
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "w-72 h-72 m-r-16" }, [
      _c("img", {
        staticClass: "width-100 height-100",
        attrs: {
          alt: "未反馈",
          src: require("@/assets/icon/employeeKanban/weifankui.png"),
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _c("th", [_vm._v("反馈类型")]),
        _c("th", [_vm._v("次数")]),
        _c("th", [_vm._v("占比")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", [
      _c("img", {
        staticClass: "w-28 h-28",
        attrs: {
          alt: "",
          src: require("@/assets/icon/employeeKanban/tablelogo.png"),
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", [
      _c("img", {
        staticClass: "w-28 h-28",
        attrs: {
          alt: "",
          src: require("@/assets/icon/employeeKanban/tablelogo.png"),
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }